import { render, staticRenderFns } from "./subdetail.vue?vue&type=template&id=416a45ec&scoped=true"
import script from "./subdetail.vue?vue&type=script&lang=js"
export * from "./subdetail.vue?vue&type=script&lang=js"
import style0 from "./subdetail.vue?vue&type=style&index=0&id=416a45ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416a45ec",
  null
  
)

export default component.exports